// extracted by mini-css-extract-plugin
export default {"body":"nI0UapZ2Ds4oOS9HdX3r"};